import { render, staticRenderFns } from "./AffinityInsertCodeRoute.vue?vue&type=template&id=70dd46f2&scoped=true&"
import script from "./AffinityInsertCodeRoute.vue?vue&type=script&lang=js&"
export * from "./AffinityInsertCodeRoute.vue?vue&type=script&lang=js&"
import style0 from "./AffinityInsertCodeRoute.vue?vue&type=style&index=0&id=70dd46f2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70dd46f2",
  null
  
)

export default component.exports